/* LADDOM header — Modules 07/08.
   Reveal-on-scroll-up, transparent-over-hero, mobile drawer with focus trap.
   Re-inits on shopify:section:load via the custom element lifecycle. */
(function () {
  'use strict';

  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

  class LdHeader extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector('.ld-header__bar');
      this.burger = this.querySelector('.ld-header__burger');
      this.drawer = this.querySelector('.ld-drawer');
      this.mode = this.dataset.sticky || 'scrollup';

      this.lastY = window.scrollY;
      this.ticking = false;
      this.open = false;

      this._onScroll = this.onScroll.bind(this);
      this._onKey = this.onKey.bind(this);

      if (this.mode !== 'none') {
        window.addEventListener('scroll', this._onScroll, { passive: true });
      }
      this.setSolid(window.scrollY > 8);

      if (this.burger) this.burger.addEventListener('click', () => this.toggle());
      this.querySelectorAll('[data-drawer-close]').forEach((el) =>
        el.addEventListener('click', () => this.close())
      );
      document.addEventListener('keydown', this._onKey);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this._onScroll);
      document.removeEventListener('keydown', this._onKey);
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      window.requestAnimationFrame(() => {
        var y = window.scrollY;
        this.setSolid(y > 8);

        // Never hide while the drawer is open.
        if (this.mode === 'scrollup' && !this.open) {
          if (y > 120 && y > this.lastY) this.classList.add('is-hidden');
          else this.classList.remove('is-hidden');
        }
        this.lastY = y;
        this.ticking = false;
      });
    }

    setSolid(on) {
      this.classList.toggle('is-solid', on);
    }

    toggle() {
      this.open ? this.close() : this.openDrawer();
    }

    openDrawer() {
      if (!this.drawer) return;
      this.open = true;
      this.drawer.hidden = false;
      // force reflow so the transition runs
      void this.drawer.offsetWidth;
      this.drawer.classList.add('is-open');
      this.burger.setAttribute('aria-expanded', 'true');
      this.classList.remove('is-hidden');

      this.scrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + this.scrollY + 'px';
      document.body.style.width = '100%';
      if (window.Motion && window.Motion.lenis) window.Motion.lenis.stop();

      var main = document.getElementById('MainContent');
      if (main) main.setAttribute('inert', '');

      var first = this.drawer.querySelector(FOCUSABLE);
      if (first) first.focus();
    }

    close() {
      if (!this.drawer || !this.open) return;
      this.open = false;
      this.drawer.classList.remove('is-open');
      this.burger.setAttribute('aria-expanded', 'false');

      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, this.scrollY || 0);
      if (window.Motion && window.Motion.lenis) window.Motion.lenis.start();

      var main = document.getElementById('MainContent');
      if (main) main.removeAttribute('inert');

      var self = this;
      window.setTimeout(function () {
        if (!self.open) self.drawer.hidden = true;
      }, 420);

      this.burger.focus();
    }

    onKey(e) {
      if (!this.open) return;
      if (e.key === 'Escape') {
        this.close();
        return;
      }
      if (e.key !== 'Tab') return;

      // Focus trap
      var nodes = Array.prototype.slice
        .call(this.drawer.querySelectorAll(FOCUSABLE))
        .filter(function (n) {
          return n.offsetParent !== null;
        });
      if (!nodes.length) return;
      var first = nodes[0];
      var last = nodes[nodes.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  if (!customElements.get('ld-header')) customElements.define('ld-header', LdHeader);
})();
